export default "__VITE_ASSET__Ba1mYq7P__"